import { Directive, ElementRef, Input, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appAddValidationClasses]'
})
export class AddValidationClassesDirective implements OnInit, OnDestroy {
  @Input('appAddValidationClasses') formControl!: FormControl;
  private statusChangeSub!: Subscription;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    // Get the inner input element within ngx-intl-tel-input
    const inputElement = this.el.nativeElement.querySelector('input');

    if (inputElement) {
      // Subscribe to status changes of the form control to dynamically apply classes
      this.statusChangeSub = this.formControl.statusChanges.subscribe(() => {
        if (this.formControl.dirty && this.formControl.invalid) {
          this.renderer.addClass(inputElement, 'ng-invalid');
        } else {
          this.renderer.removeClass(inputElement, 'ng-invalid');
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.statusChangeSub) {
      this.statusChangeSub.unsubscribe();
    }
  }
}
